import PropTypes from 'prop-types';

export const UnitDisplayType = {
  Abbreviated: 'Abbreviated',
  AbbreviatedWithParentheses: 'AbbreviatedWithParentheses',
};

export const UnitDisplayTypePropType = PropTypes.oneOf([UnitDisplayType.Abbreviated, UnitDisplayType.AbbreviatedWithParentheses]);
